import * as yup from 'yup'
import { defineMessages } from 'react-intl'
import { isEmpty } from 'lodash'

const messages = defineMessages({
  required: {
    id: 'dictionary.required',
    defaultMessage: 'Required'
  }
})

const companyMessages = defineMessages({
  required: {
    id: 'fareFamilies.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const segmentsMessages = defineMessages({
  required: {
    id: 'fareFamilies.form.segments.required',
    defaultMessage: 'You need to select at least one segment'
  }
})

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
const testCompanyIsRequired = (value, canEditCompany): TSFixMe => {
  if (canEditCompany) {
    return !isEmpty(value)
  }

  return true
}

export const schema = (
  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  intl,
  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  canEditCompany
): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().test('is-company-required', intl.formatMessage(companyMessages.required), function (value) {
        return testCompanyIsRequired(value, canEditCompany)
      })
    }),
    segments: yup.array().min(1, intl.formatMessage(segmentsMessages.required)),
    fares: yup.array().of(
      yup.object().shape({
        basePrice: yup.string().required(intl.formatMessage(messages.required)),
        bookingClass: yup.object().shape({
          id: yup.string().required(intl.formatMessage(messages.required))
        }),
        type: yup.string().required(intl.formatMessage(messages.required)),
        seasonType: yup.string().required(intl.formatMessage(messages.required)),
        timeWindow: yup.string().required(intl.formatMessage(messages.required)),
        dow: yup.string().required(intl.formatMessage(messages.required)),
        demand: yup.string().required(intl.formatMessage(messages.required)),
        salesChannel: yup.string().required(intl.formatMessage(messages.required)),
        serviceType: yup.string().required(intl.formatMessage(messages.required))
      })
    )
  })
}
